// Initializing status
var ChannelStateTypes = /*#__PURE__*/function (ChannelStateTypes) {
  ChannelStateTypes["NIL"] = "NIL";
  ChannelStateTypes["LOADING"] = "LOADING";
  ChannelStateTypes["INVALID"] = "INVALID";
  ChannelStateTypes["INITIALIZED"] = "INITIALIZED";
  return ChannelStateTypes;
}({});
var ParentMessageStateTypes = /*#__PURE__*/function (ParentMessageStateTypes) {
  ParentMessageStateTypes["NIL"] = "NIL";
  ParentMessageStateTypes["LOADING"] = "LOADING";
  ParentMessageStateTypes["INVALID"] = "INVALID";
  ParentMessageStateTypes["INITIALIZED"] = "INITIALIZED";
  return ParentMessageStateTypes;
}({});
var ThreadListStateTypes = /*#__PURE__*/function (ThreadListStateTypes) {
  ThreadListStateTypes["NIL"] = "NIL";
  ThreadListStateTypes["LOADING"] = "LOADING";
  ThreadListStateTypes["INVALID"] = "INVALID";
  ThreadListStateTypes["INITIALIZED"] = "INITIALIZED";
  return ThreadListStateTypes;
}({});
export { ChannelStateTypes, ParentMessageStateTypes, ThreadListStateTypes };